var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.7002,
    cy: 34,
    r: 34,
    fill: "url(#paint0_linear_184_3683)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9511 40.8062C47.0349 39.8832 44.816 38.5361 43.7395 37.9933C42.3375 37.2871 42.2221 37.2294 41.1202 38.0481C40.3851 38.5944 39.8965 39.0824 39.0363 38.899C38.176 38.7155 36.3068 37.6811 34.67 36.0497C33.0332 34.4182 31.9388 32.4948 31.7547 31.6376C31.5707 30.7803 32.0669 30.2974 32.608 29.5607C33.3707 28.5223 33.313 28.3492 32.6611 26.9474C32.1528 25.857 30.7664 23.6591 29.8399 22.7476C28.8487 21.7686 28.8487 21.9416 28.21 22.207C27.6901 22.4258 27.1913 22.6917 26.7198 23.0014C25.7967 23.6146 25.2844 24.124 24.9261 24.8896C24.5678 25.6551 24.4069 27.4499 26.2571 30.8109C28.1073 34.1719 29.4054 35.8905 32.0922 38.5696C34.779 41.2487 36.8451 42.6892 39.8653 44.383C43.6016 46.4754 45.0347 46.0675 45.8026 45.7098C46.5705 45.3522 47.0822 44.8445 47.6967 43.9215C48.0072 43.4508 48.2737 42.9526 48.4928 42.4331C48.7588 41.7967 48.9319 41.7967 47.9511 40.8062Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184_3683",
    x1: -5.0617,
    y1: 77.9556,
    x2: 42.3759,
    y2: 64.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#00D5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AA4C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.a5f0b43262339f3137891b0949d6cade.svg";
export { ForwardRef as ReactComponent };